import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import DropDown from "components/ui/controls/drop-down/drop-down";
import TextField from "components/ui/controls/text-field/text-field";

function ContratPrevCondGenSalarie(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row tpad>
              <Column>
                <DropDown
                  label="Versement des prestations"
                  value={context.state.ContratPrevoyance}
                  onChange={context.handleInputChange("ContratPrevoyance")}
                  options={[
                    { value: "indemnitaire", label: "Déduction du régime obligatoire" },
                    { value: "forfaitaire", label: "Complément du régime obligatoire" },
                  ]}
                  xlarge
                />
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default ContratPrevCondGenSalarie;
